
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mathmagic",
      function () {
        return require("private-next-pages/mathmagic/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mathmagic"])
      });
    }
  